var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6567 11.8286L13.8283 9.00019L10.9999 11.8286",
    stroke: "#FF6520",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8284 9.32861L13.8284 16.3286",
    stroke: "#FF6520",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 21.8C2.885 21.8 2.27313 21.5456 1.7644 21.0369C1.2548 20.5273 1 19.915 1 19.2V3.6C1 2.885 1.2548 2.27313 1.7644 1.7644C2.27313 1.2548 2.885 1 3.6 1H10.3275C10.6742 1 11.0048 1.065 11.3194 1.195C11.6331 1.325 11.9092 1.50917 12.1475 1.7475L14 3.6H24.4C25.115 3.6 25.7273 3.8548 26.2369 4.3644C26.7456 4.87313 27 5.485 27 6.2V19.2C27 19.915 26.7456 20.5273 26.2369 21.0369C25.7273 21.5456 25.115 21.8 24.4 21.8H3.6Z",
    stroke: "#FF6520",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.e31af8cf0a440ec8276c1f88a85e8eed.svg";
export { ForwardRef as ReactComponent };